import React from 'react';
import './index.css';
import App from './App';
import {SnackBarContextProvider} from "./providers/snackbar-context";
import * as serviceWorker from './serviceWorker';
import * as ReactDOMClient from 'react-dom/client';
import "@nike/eds/dist/index.css";
import {BrowserRouter} from "react-router-dom";

let flowOverviewContainer = null;
let root = null;

/////for testing purposes
// let containerId = 'root'
// flowOverviewContainer = document.getElementById(containerId);
// root = ReactDOMClient.createRoot(flowOverviewContainer);
// root.render(
//     <React.StrictMode>
//         <BrowserRouter>
//             <App />
//         </BrowserRouter>
//     </React.StrictMode>
// );
/////


window.renderFlowOverview = (containerId, history, {locationTracker, host, permissions}) => {
    if (!flowOverviewContainer) {
        flowOverviewContainer = document.getElementById(containerId);
        root = ReactDOMClient.createRoot(flowOverviewContainer);
        root.render(
            <React.StrictMode>
                <BrowserRouter>
                    <SnackBarContextProvider>
                        <App history={history} locationTracker={locationTracker} host={host} permissions={permissions}/>
                    </SnackBarContextProvider>
                </BrowserRouter>
            </React.StrictMode>
        );
        serviceWorker.unregister();
    }
};

window.unmountFlowOverview = containerId => {
    root.unmount()
    flowOverviewContainer = null;
    root = null;
};

if (!document.getElementById('FlowOverview-container')) {
    //root.render(<App />);
    serviceWorker.unregister();
}


